
const ethereum: any = window["ethereum"];

export class SystemService {
  async getReqAccounts(): Promise<any[]> {
    return await ethereum.request({ method: "eth_requestAccounts" });
  }
  async getAccounts(): Promise<any[]> {
    return await ethereum.request({ method: "eth_accounts" });
  }

  async isUserLoggined(): Promise<boolean> {
    const accounts = await this.getAccounts();
    return accounts.length !== 0;
  }
}
